import styled, { css } from 'styled-components'

import { IProps as IButtonProps } from './Button'

export const ButtonStyles = styled.button<IButtonProps>`
  width: 100%;
  max-width: 343px;
  min-height: 48px;
  display: block;
  margin: 0 auto;
  padding: 10px 16px;
  cursor: pointer;
  border: none;
  outline: none;
  border-radius: 8px;
  /* background: #009ffa; */
  background: ${({ theme }) => theme.colors.buttonBackground};
  font-size: 17px;
  font-weight: 800;
  line-height: 24px;
  text-decoration: none;
  text-align: center;
  color: ${({ theme }) => theme.colors.buttonColor};
  transition: all 0.4s ease-out;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  touch-action: manipulation;

  ${({ variant }) =>
    variant === 'plain' &&
    css`
      background: transparent;
      height: auto;
      color: ${({ theme }) => theme.colors.hintColor};
      padding: 0;
      margin-top: 16px;
      width: auto;
    `}

  /* &:hover:not(:disabled) {
    transform: translateY(-2px) scale(1.02);
  } */

  &:disabled {
    &:disabled {
      background: ${({ theme }) => theme.colors.disabledButtonBackground};
    }
  }
`
